import { render, staticRenderFns } from "./ProductSalesPeriodPopupIframe.vue?vue&type=template&id=18340ff4&"
import script from "./ProductSalesPeriodPopupIframe.vue?vue&type=script&lang=ts&"
export * from "./ProductSalesPeriodPopupIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports